
import { computed, defineComponent, markRaw, onMounted, onUnmounted, ref, shallowRef, watch } from 'vue'
import * as echarts from 'echarts'
import _ from 'lodash'
import initChartAutoResize from './chartAutoResizeService'

export default defineComponent({
  props: {
    options: Object,
    isEmpty: Boolean,
    updateOption: Object,
    theme: [Object, String],
    chartOption: Object,
    autoResize: Boolean
  },

  emits: ['chart-resize'],

  setup (props, { emit }) {
    const internalMyChart = { value: undefined as any }
    const myChart = computed(() => internalMyChart.value)
    const chart = ref()

    function resize () {
      if (!internalMyChart.value || _.get(chart.value, 'clientWidth', 0) <= 0) {
        return
      }
      internalMyChart.value.resize()
      emit('chart-resize')
    }

    function updateOption () {
      if (!internalMyChart.value || !props.options) {
        return
      }
      internalMyChart.value.setOption(props.options, props.updateOption)
    }

    onMounted(() => {
      internalMyChart.value = echarts.init(chart.value, props.theme, props.chartOption)
      updateOption()

      window.addEventListener('resize', resize)

      watch(() => props.options, () => {
        updateOption()
      }, { deep: true })
    })

    onUnmounted(() => {
      window.removeEventListener('resize', resize)
    })

    initChartAutoResize(props, chart, resize)

    function getChartInstance () {
      return internalMyChart.value
    }

    return {
      internalMyChart,
      myChart,
      chart,
      resize,
      getChartInstance
    }
  }
})
